import type { IntervalUnit, PartType } from '../../types';

const WEAR_PART_UNITS: readonly IntervalUnit[] = ['flights', 'hours'];

const BATTERY_UNITS: readonly IntervalUnit[] = ['cycles'];

const UNITS_BY_PART: Partial<Record<PartType, readonly IntervalUnit[]>> = {
    battery: BATTERY_UNITS
};

export const getAvailableUnits = ({ part }: { part: PartType }): readonly IntervalUnit[] =>
    UNITS_BY_PART[part] ?? WEAR_PART_UNITS;
